export default {
  build: 'Build',
  better_games: 'Better games, faster',
  download_view_more: '浏览更多',
  client_side_sdk: '客户端 SDK',
  server_side_sdk: '服务端 SDK',
  download_tools: '工具',
  sample_demo: '演示示例',
  download_engine: '引擎',
  supporting_system: '支持系统',
  download_format: '格式',
  download_microservice_format: '支持环境',
  download_latest: '最新',
  download_whitelist: '白名单',
  download_list_number: '下载列表 · {{listNumber}}',
  download_list_empty: '尚未选择要下载的内容',
  download_list_btn: '下载',
  download_modal_title: '下载准备中',
  dowload_step_one: '步骤1',
  dowload_step_two: '步骤2',
  link_to_the_title: '关联至游戏',
  packaging_integration: '打包&集成',
  download_list_tips:
    '当您选择游戏时，我们会在软件包主体中自动注入一些参数，这些参数也可以在下载完后根据文档手动替换',
  download_studio: '工作室',
  download_tips_fetching: '从远端服务器拉取包体中...',
  download_tips_unzipping: '包体解压缩，参数注入中...',
  download_tips_generated: '正在生成软件包...',
  download_tips_uploading: '软件包重新上传中...',
  download_tips_cdn: 'CDN 预热，任务进行中...',
  download_tips_success: '任务执行成功，唤醒浏览器下载...',
  cancel_download: '取消下载',
  cancel_download_time_remaining_tips:
    '大约还有 {{timeRemaining}} 分钟打包完成，确定取消下载吗?',
  cancel_download_btn_continue: '继续',
  cpp: 'C++',
  ue_plugin: 'UE插件',
  unity_plugin: 'Unity插件',
  ps_sdk: 'PS SDK',
  gdk: 'GDK',
  please_select_studio: '请选择工作室',
  please_select_game: '请选择游戏',
  please_select_env: '请选择环境',
  cancel_download_success: '取消下载成功!',
  cancel_download_failed: '取消下载失败!',
  host_platform: '主机平台',
  computer_platform: 'PC平台',
  mobile_platform: '移动平台',
  show_update_time: '更新时间：',
  ps_sdk_version_and_gdk_version_required:
    '此引擎的PS SDK Version和GDK Version需必填',
  ps_sdk_version_required: '此引擎的PS SDK Version需必填',
  gdk_version_required: '此引擎的GDK Version需必填',
  download_failed: '下载失败或10分钟内下载超过5次。',
  client_platform_unselected: '请先选择发行平台。',
  client_platform_nonsupport: '没有符合条件的SDK。',
  comingSoon: '即将上线',
  service_download_options: '可选下载服务',
  downloaded_sdk_selected_tips:
    '为精简包体大小，InGameSDK支持按以下服务维度拆分下载，您下载的SDK中将不会包含未勾选的服务内容。',
  does_not_support: '{{name}} 暂不支持 {{config}}',
  include_second: '(包含 {{name}})',
};
